import { useMemo } from "react";
import { useParams } from "react-router-dom";
import * as Bananas from "bananas-commerce-admin";

import { useObituary } from "@/extensions/mediahouse/hooks/useObituary";

import AdCard from "./AdCard";
import OrderCard from "./OrderCard";
import ReviewAdCard from "./ReviewAdCard";
import { ReviewAdDialogType } from "./ReviewAdDialog";

const OrderDetailPage: Bananas.types.PageComponent = () => {
  const { t } = Bananas.useI18n();
  const { obituary_id } = useParams();
  const obituaryId = Number(obituary_id);
  const { data, refresh } = useObituary(obituaryId);
  const pendingType: ReviewAdDialogType = useMemo(
    () =>
      data?.status === "pending_cancellation_review"
        ? "cancellation"
        : data?.status === "sent" && data?.version > 1
          ? "edit"
          : "new",
    [data],
  );
  const showReviewCard =
    data?.status === "pending_mediahouse_review" ||
    data?.status === "pending_cancellation_review";

  return (
    <Bananas.Page>
      <Bananas.ContentWrapperWithActionBar>
        <Bananas.Header pb={2} variant="opaque">
          <Bananas.TitleBar
            title={t("Order") + " #" + data?.id}
          ></Bananas.TitleBar>
        </Bananas.Header>
        <Bananas.Content layout="fixedWidth">
          <Bananas.TwoColumn>
            <Bananas.LeftColumn>
              {showReviewCard && (
                <ReviewAdCard
                  obituaryId={obituaryId}
                  refresh={refresh}
                  type={pendingType}
                />
              )}
              <OrderCard data={data} />
            </Bananas.LeftColumn>

            <Bananas.RightColumn>
              {data && <AdCard obituaryMedia={data} />}
            </Bananas.RightColumn>
          </Bananas.TwoColumn>
        </Bananas.Content>
      </Bananas.ContentWrapperWithActionBar>
    </Bananas.Page>
  );
};

export default OrderDetailPage;
